import React, { useState, useEffect } from 'react';

const GENRES_DATA = [
  { id: 'A', name: '消化管', sections: ['A01', 'A02', 'A03', 'A04', 'A05', 'A06', 'A07'] },
  { id: 'B', name: '肝胆膵', sections: ['B01', 'B02', 'B03','B04', 'B05', 'B06', 'B07', 'B08', 'B09', 'B10'] },
  { id: 'C', name: '循環器', sections: ['C01', 'C02', 'C03','C04', 'C05', 'C06', 'C07', 'C08', 'C09', 'C10','C11', 'C12'] },
  { id: 'D', name: '内分泌・代謝', sections: ['D01', 'D02', 'D03', 'D04', 'D05', 'D06', 'D07', 'D08', 'D09'] },
  { id: 'E', name: '腎・泌尿器', sections: ['E01', 'E02', 'E03', 'E04', 'E05', 'E06', 'E07', 'E08'] },
  { id: 'F', name: '免疫・膠原病', sections: ['F01', 'F02', 'F03', 'F04'] },
  { id: 'G', name: '血液', sections: ['G01', 'G02', 'G03', 'G04', 'G05', 'G06', 'G07'] },
  { id: 'H', name: '感染症', sections: ['H01', 'H02', 'H03', 'H04', 'H05', 'H06', 'H07', 'H08', 'H09', 'H10', 'H11', 'H12', 'H13', 'H14', 'H15'] },
  { id: 'I', name: '呼吸器', sections: ['I01', 'I02', 'I03', 'I04', 'I05', 'I06', 'I07', 'I08', 'I09', 'I10'] },
  { id: 'J', name: '神経', sections: ['J01', 'J02', 'J03', 'J04', 'J05', 'J06', 'J07', 'J08', 'J09', 'J10', 'J11', 'J12'] },
  { id: 'KL', name: '救急・中毒', sections: ['KL01', 'KL02', 'KL03', 'KL04', 'KL05', 'KL06', 'KL07', 'KL08'] },
  { id: 'L', name: '輸液', sections: ['L01', 'L02', 'L03'] },
  { id: 'M', name: '麻酔', sections: ['M01', 'M02', 'M03'] },
  { id: 'O', name: '小児科', sections: ['O01', 'O02', 'O03', 'O04', 'O05', 'O06', 'O07', 'O08', 'O09'] },
  { id: 'P', name: '乳腺', sections: ['P01', 'P02'] },
  { id: 'PQ', name: '産婦人科', sections: ['PQ01', 'PQ02', 'PQ03', 'PQ04', 'PQ05', 'PQ06', 'PQ07', 'PQ08', 'PQ09', 'PQ10', 'PQ11', 'PQ12', 'PQ13'] },
  { id: 'R', name: '眼科', sections: ['R01', 'R02', 'R03', 'R04', 'R05', 'R06', 'R07', 'R08', 'R09', 'R10'] },
  { id: 'S', name: '耳鼻咽喉科', sections: ['S01', 'S02', 'S03', 'S04'] },
  { id: 'T', name: '整形外科', sections: ['T01', 'T02', 'T03', 'T04', 'T05', 'T06', 'T07'] },
  { id: 'U', name: '精神科', sections: ['U01', 'U02', 'U03', 'U04', 'U05', 'U06', 'U07', 'U08', 'U09', 'U10','U11', 'U12'] },
  { id: 'V', name: '皮膚科', sections: ['V01', 'V02', 'V03','V04', 'V05', 'V06', 'V07', 'V08', 'V09'] },
  { id: 'W', name: '泌尿器科', sections: ['W01', 'W02', 'W03','W04', 'W05', 'W06', 'W07', 'W08', 'W09'] },
  { id: 'X', name: '放射線科', sections: ['X01', 'X02', 'X03','X04'] },
];

const LEVELS = [
  { key: 'unplayed', label: '未演習', color: '#95a5a6', bg: '#f8f9fa' },
  { key: 'x',       label: '×',     color: '#e74c3c', bg: '#fdf2f2' },
  { key: 'tri',     label: '△',     color: '#f39c12', bg: '#fef9e7' },
  { key: 'o',       label: '〇',     color: '#2ecc71', bg: '#eafaf1' },
  { key: 'oo',      label: '◎',     color: '#3498db', bg: '#ebf5fb' },
];

const GenreScreen = ({ onSelect, onBack, onSelectRandom, initialGroup, onSelectSaved }) => {
  const [activeGroup, setActiveGroup] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);

  // ★ initialGroup が変わったら反映（nullなら一覧に戻す）
  useEffect(() => {
    if (initialGroup) {
      const found = GENRES_DATA.find(g => g.id === initialGroup);
      setActiveGroup(found ?? null);
    } else {
      setActiveGroup(null);
    }
  }, [initialGroup]);

  const savedCount = (() => {
    const saved = localStorage.getItem('saved_questions');
    return saved ? JSON.parse(saved).length : 0;
  })();

  const toggleFilter = (key) => {
    setActiveFilters(prev =>
      prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );
  };

  const handleSelectWithFilter = (genreId, sectionId) => {
    if (activeFilters.length === 0) {
      onSelect(genreId, sectionId);
      return;
    }
    onSelect(genreId, sectionId, activeFilters);
  };

  // --- 1. ジャンル一覧画面 ---
  if (!activeGroup) {
    return (
      <div className="glass-card" style={{ maxWidth: '900px', width: '95%' }}>
        <h2 style={{ fontSize: '1.5rem', color: '#2c3e50', marginBottom: '20px' }}>ジャンル選択</h2>

        {savedCount > 0 && (
          <button className="playful-btn"
            style={{ background: '#f39c12', marginBottom: '20px', width: '100%' }}
            onClick={onSelectSaved}>
            ⭐ 保存した問題を演習（{savedCount}問）
          </button>
        )}

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
          {GENRES_DATA.map(g => (
            <div key={g.id} className="genre-card" onClick={() => setActiveGroup(g)}
              style={{ cursor: 'pointer', width: '140px', padding: '15px 5px', textAlign: 'center' }}>
              <span style={{ display: 'block', fontSize: '0.75rem', color: '#3498db', fontWeight: '800' }}>{g.id}</span>
              <span style={{ fontSize: '0.9rem', color: '#2c3e50', fontWeight: 'bold' }}>{g.name}</span>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #eee', width: '100%', textAlign: 'center' }}>
          <button onClick={onBack} style={{
            background: '#f8f9fa', border: '2px solid #e1e8ed', padding: '12px 30px',
            borderRadius: '50px', color: '#7f8c8d', fontSize: '0.9rem',
            fontWeight: 'bold', cursor: 'pointer'
          }}>
            タイトルに戻る
          </button>
        </div>
      </div>
    );
  }

  // --- 2. 小ジャンル（セクション）選択画面 ---
  return (
    <div className="glass-card" style={{ maxWidth: '600px', width: '95%' }}>
      <header style={{ marginBottom: '20px' }}>
        <span style={{ color: '#3498db', fontWeight: 'bold' }}>{activeGroup.id}</span>
        <h2 style={{ margin: '0', color: '#2c3e50' }}>{activeGroup.name}</h2>
      </header>

      {/* 理解度フィルター */}
      <div style={{ marginBottom: '20px', width: '100%' }}>
        <div style={{ fontSize: '0.75rem', color: '#95a5a6', marginBottom: '8px' }}>
          理解度で絞り込み（複数選択可・未選択=全問出題）
        </div>
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'nowrap', overflowX: 'auto', paddingBottom: '4px' }}>
          {LEVELS.map(lv => {
            const isActive = activeFilters.includes(lv.key);
            return (
              <button key={lv.key} onClick={() => toggleFilter(lv.key)}
                style={{
                  padding: '7px 10px', borderRadius: '20px',
                  border: `2px solid ${isActive ? lv.color : '#e1e8ed'}`,
                  background: isActive ? lv.bg : 'white',
                  color: isActive ? lv.color : '#bdc3c7',
                  fontWeight: 'bold', cursor: 'pointer',
                  fontSize: '0.8rem', transition: 'all 0.15s',
                  whiteSpace: 'nowrap', flexShrink: 0,
                }}>
                {lv.label}
              </button>
            );
          })}
          {activeFilters.length > 0 && (
            <button onClick={() => setActiveFilters([])}
              style={{
                padding: '7px 10px', borderRadius: '20px',
                border: '2px solid #e1e8ed', background: 'white',
                color: '#e74c3c', fontWeight: 'bold', cursor: 'pointer',
                fontSize: '0.8rem', whiteSpace: 'nowrap', flexShrink: 0,
              }}>
              リセット
            </button>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <button className="playful-btn" onClick={() => handleSelectWithFilter(activeGroup.id, 'ALL')}>
          このジャンルからランダムに出題
        </button>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
          {activeGroup.sections.map(sec => (
            <button key={sec} className="chip-btn"
              onClick={() => handleSelectWithFilter(activeGroup.id, sec)}
              style={{ minWidth: '70px' }}>
              {sec}
            </button>
          ))}
        </div>
      </div>

      <button onClick={() => setActiveGroup(null)} style={{
        marginTop: '30px', background: '#f8f9fa', border: 'none',
        padding: '10px 20px', borderRadius: '50px', cursor: 'pointer',
        color: '#7f8c8d', fontWeight: 'bold'
      }}>
        ← ジャンル一覧へ戻る
      </button>
    </div>
  );
};

export default GenreScreen;